<template>
  <v-container class="px-2 py-2" fluid v-if="isSearched">
    <v-row dense>
      <v-col>
        <InspIndexDetail :indexDetail="indexDetail" :inspClassCd="enumInspClassCd.DIM" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-form :disabled="!canEdit">
          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-card class="py-2" outlined>
              <v-card-title class="py-0"> {{ $t('ELE0188') }} </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="4">
                    <v-container class="px-0 py-2">
                      <v-row>
                        <v-col>
                          <DatetimePicker v-model="inspStartDatetime" disableFutureDatetime required />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <InspTimingDtlInput
                            v-if="canEdit"
                            v-model="searchResult.inspTimingDtlCd"
                            :companyCatCd="companyCatCd"
                            :inspTimingCd="indexDetail.inspTimingCd"
                            :inspClassCd="enumInspClassCd.DIM"
                            :inspCat2Cd="indexDetail.inspCat2Cd"
                            required
                          />
                          <InspTimingDtlInput v-else v-model="searchResult.inspTimingDtlCd" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <!--記号入力も許可している-->
                        <v-col class="py-1">
                          <TextFieldInput
                            :label="$t('ELE0157')"
                            v-model="cavComputed"
                            :maxLength="cavLimit"
                            rules="halfWidth"
                            required
                            @change="setNumOfInsp()"
                            v-if="isNew"
                          />
                          <TextFieldRef :label="$t('ELE0157')" :value="cavComputed" v-else />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <TextFieldRef :label="$t('ELE0098')" v-model="numOfInspComputed" right />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <TextFieldInputWithDatePicker
                            :label="$t('ELE0138')"
                            v-model="searchResult.inspDate"
                            disableFutureDate
                            required
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <InspectorInput
                            v-model="searchResult.inspectorCd"
                            :validOnly="canEdit"
                            :disabled="!canEdit"
                            required
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <TextFieldInput
                            :label="$t('ELE0175')"
                            v-model="searchResult.inspQty"
                            :rules="`rangeNumber:1,${indexDetail.aqlDetermQty}`"
                            required
                            right
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                  <v-col>
                    <v-container fluid fill-height class="px-0 py-0">
                      <v-row>
                        <v-col>
                          <TextAreaInput
                            v-if="canEdit"
                            :label="$t('ELE0054')"
                            v-model="searchResult.remarks"
                            :maxLength="1000"
                          />
                          <TextAreaRef v-else :label="$t('ELE0054')" :value="searchResult.remarks" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <BtnAttach :disabled="!fileAttachmentBtnComputed" @click="inspFileAttachDialog = true" />
                        </v-col>
                      </v-row>
                      <v-row align="end">
                        <v-col>
                          <Btn
                            class="mx-2"
                            :label="$t('ELE0186')"
                            :disabled="samplingBoxes.length == 0"
                            @click="samplingBoxDialog = true"
                          />
                          <Btn
                            class="mx-2"
                            :label="$t('ELE0034')"
                            :disabled="!hasInspPoint"
                            @click="inspAttachDialog = true"
                          />
                          <v-badge
                            bordered
                            color="error"
                            icon="mdi-exclamation-thick"
                            overlap
                            :value="canSelectSa && !isConfirmedSa"
                          >
                            <Btn
                              class="mx-2"
                              :label="$t('ELE0383')"
                              :disabled="saItems.length == 0"
                              @click="selectSaDialog = true"
                            />
                          </v-badge>
                        </v-col>
                      </v-row>
                      <v-row></v-row>
                      <v-row align="end">
                        <v-spacer />
                        <v-col class="pt-2 d-flex justify-end">
                          <Checkbox :label="$t('ELE0189')" v-model="isComplete" />
                        </v-col>
                        <v-col>
                          <TextFieldRef
                            :label="$t('ELE0188')"
                            :value="
                              showInspResultName('InspResultCd.', searchResult.inspResultCd, searchResult.isOutCl)
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <v-card outlined class="px-0 py-0">
                      <v-card-title class="pt-0 pb-3">
                        <v-row dense>
                          <v-col class="mt-1" cols="4">
                            {{ $t('ELE0202') }}
                          </v-col>
                          <v-col cols="3">
                            <BtnCsvDownload
                              :label="$t('ELE0076')"
                              :fileTitle="csvFileTitle"
                              :items="csvContents"
                              :disabled="!inspCharacExists"
                            />
                          </v-col>
                          <v-col class="pt-1" cols="4">
                            <FileInput :label="$t('ELE0208')" multiple v-model="files" />
                          </v-col>
                          <v-col>
                            <BtnImport
                              class="mt-1"
                              @click="onClickImport"
                              :disabled="invalid || !canEdit || files.length <= 0"
                            />
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <v-card outlined>
                          <v-data-table
                            :headers="headers"
                            :items="searchResult.characs"
                            dense
                            fixed-header
                            disable-pagination
                            hide-default-footer
                            :height="tableHeight"
                            mobile-breakpoint="0"
                          >
                            <template #header>
                              <thead>
                                <tr>
                                  <th colspan="3"></th>
                                  <th :colspan="drawingStandardColSpan" class="v-data-table__divider normal-cell">
                                    {{ $t('ELE0179') }}
                                  </th>
                                  <th colspan="3" class="v-data-table__divider sa-cell">{{ $t('ELE0180') }}</th>
                                  <th colspan="6" class="v-data-table__divider"></th>
                                  <th :colspan="headers.length" class="v-data-table__divider">
                                    {{ $t('ELE0202') }}
                                    <IconEdit class="ml-2" @click="onClickEdit" :disabled="invalid || !canEdit" />
                                  </th>
                                </tr>
                              </thead>
                            </template>
                            <template v-slot:item.inspQltyStd="{ item }">
                              <table v-if="item.inspStd || item.qltyStd1 || item.qltyStd2 || item.qltyStd3">
                                <tr v-if="item.inspStd">
                                  <td>{{ $t('ELE0388') }} : {{ item.inspStd }}</td>
                                </tr>
                                <tr v-if="item.qltyStd1">
                                  <td>{{ $t('ELE0389') }} : {{ item.qltyStd1 }}</td>
                                </tr>
                                <tr v-if="item.qltyStd2">
                                  <td>{{ $t('ELE0390') }} : {{ item.qltyStd2 }}</td>
                                </tr>
                                <tr v-if="item.qltyStd3">
                                  <td>{{ $t('ELE0391') }} : {{ item.qltyStd3 }}</td>
                                </tr>
                              </table>
                            </template>
                            <template v-slot:[`item.measResultCd`]="{ item }">
                              <td
                                class="v-data-table__divider"
                                :style="{ 'background-color': getColorMeasResult(item.measResultCd) }"
                              >
                                {{ showInspResultName('MeasResultCd.', item.measResultCd, item.isOutCl) }}
                              </td>
                            </template>
                            <template v-slot:[`item.measValue1`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue1_' + index"
                                v-model="item.measValue1"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue2`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue2_' + index"
                                v-model="item.measValue2"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue3`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue3_' + index"
                                v-model="item.measValue3"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue4`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue4_' + index"
                                v-model="item.measValue4"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue5`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue5_' + index"
                                v-model="item.measValue5"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue6`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue6_' + index"
                                v-model="item.measValue6"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue7`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue7_' + index"
                                v-model="item.measValue7"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue8`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue8_' + index"
                                v-model="item.measValue8"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue9`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue9_' + index"
                                v-model="item.measValue9"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue10`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue10_' + index"
                                v-model="item.measValue10"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue11`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue11_' + index"
                                v-model="item.measValue11"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue12`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue12_' + index"
                                v-model="item.measValue12"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-slot:[`item.measValue13`]="{ item, index }">
                              <MeasValueInput
                                :vid="'measValue13_' + index"
                                v-model="item.measValue13"
                                :measFmtCd="item.measFmtCd"
                                :disabled="!canEditMeasValue"
                                @change="setCharacResult(index)"
                              />
                            </template>
                            <template v-for="str in measResultCols" v-slot:[`item.${str}`]="{ item }">
                              {{ formatValue(item[str], item.measFmtCd) }}
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-spacer />
                  <v-col class="d-flex justify-end">
                    <BtnDelete
                      class="mx-2"
                      :label="$t('ELE0036')"
                      :disabled="!canDelete"
                      @click="confirmDialog = true"
                    />
                    <BtnSave :label="$t('ELE0019')" :disabled="invalid || !canSave" @click="onClickSave" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </validation-observer>
        </v-form>
      </v-col>
    </v-row>

    <v-dialog v-if="inspAttachDialog" v-model="inspAttachDialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0191') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="inspAttachDialog = false" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text>
          <InspAttachmentForm :partCd="indexDetail.partCd" isInquiry />
        </v-card-text>
      </v-card>
    </v-dialog>

    <SearchBoxSamplingDialog
      :dialog.sync="samplingBoxDialog"
      :inspIndexNo="inspIndexNoComputed"
      :cav="cavComputed"
      :numOfInsp="numOfInspComputed"
      :boxes="samplingBoxes"
    />

    <DelConfirmDialog
      :dialog="confirmDialog"
      :confirmWord="$t('MSG0013')"
      :btnLabel="$t('ELE0036')"
      @cancel="confirmDialog = false"
      @proceed="onProceedDelete"
    />

    <NumConfirmDialog
      :dialog="numConfirmDialog"
      :confirmWord="$t('MSG0086', { p0: this.cavComputed })"
      :confirmLastWord="$t('MSG0087')"
      :btnLabel="$t('ELE0019')"
      @cancel="numConfirmDialog = false"
      @proceed="onProceedSave"
    />

    <ImpDataErrorDialog
      :dialog.sync="ImpInspDataErrorDialog"
      :files.sync="files"
      :errorLineCount="errorLineCount"
      :errorList="errorList"
      @import="onClickImport"
    />

    <SelectSaDialog
      :dialog.sync="selectSaDialog"
      :propsItems="saItems"
      :disabled="!canSelectSa"
      @close="isConfirmedSa = true"
      @set="applySa"
    />
    <div v-if="inspFileAttachDialog">
      <InspectionFileAttachmentDialog
        :dialog.sync="inspFileAttachDialog"
        :headerTitle="$t('ELE0229')"
        :attachedFiles="attachedFilesComputed"
        :isInquiry="!canEdit"
        :inspIndexNo="searchResult.inspIndexNo"
        :cav="cavComputed"
        :numOfInsp="numOfInspComputed"
        @set="onSetAttachedFiles"
      />
    </div>
  </v-container>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'
import { Storage } from '@/plugins/storage'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import StringUtils from '@/mixin/string-utils.js'
import DateUtil from '@/mixin/date-utils.js'
import CheckUtil from '@/mixin/check-utils.js'
import { InspStatusCd, DimJudgeCd, MeasResultCd, MeasFmtCd, InspClassCd, SystemParameterKey, S3Root } from '@/enum'
import moment from 'moment'
import BigNumber from 'bignumber.js'

import Btn from '@/components/atoms/base/button/Btn.vue'
import BtnAttach from '@/components/atoms/button/BtnAttach.vue'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnAdd from '@/components/atoms/button/BtnAdd'
import BtnDelete from '@/components/atoms/button/BtnDelete'
import BtnSave from '@/components/atoms/button/BtnSave'
import BtnCsvDownload from '@/components/atoms/button/BtnCsvDownload'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import TextAreaInput from '@/components/atoms/base/text-field/TextAreaInput'
import TextAreaRef from '@/components/atoms/base/text-field/TextAreaRef'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import IconEdit from '@/components/atoms/icon/IconEdit'

import SearchBoxSamplingDialog from '@/components/organisms/terminal/dialog/SearchBoxSamplingDialog'
import InspAttachmentForm from '@/components/organisms/master/form/InspAttachmentForm'
import InspIndexDetail from '@/components/organisms/terminal/card/InspIndexDetail'
import UserInput from '@/components/atoms/select/UserInput'
import InspectorInput from '@/components/atoms/select/InspectorInput'
import MeasValueInput from '@/components/atoms/input/MeasValueInput'
import DelConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'
import NumConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'
import DatetimePicker from '@/components/atoms/text-field/DatetimePicker'
import ImpDataErrorDialog from '@/components/organisms/terminal/dialog/ImpDataErrorDialog'
import InspectionFileAttachmentDialog from '@/components/organisms/terminal/dialog/InspectionFileAttachmentDialog'
import BtnImport from '@/components/atoms/button/BtnImport'
import FileInput from '@/components/atoms/base/file/FileInput'
import SelectSaDialog from '@/components/organisms/terminal/dialog/SelectSaDialog'
import InspTimingDtlInput from '@/components/atoms/select/InspTimingDtlInput'

/** 最大測定回数 */
const MAX_NUM_OF = 13

export default {
  name: 'InputDimInspForm',

  mixins: [APIUtils, Message, Loading, DateUtil, CheckUtil, StringUtils],

  components: {
    ValidationObserver,
    Btn,
    BtnSearch,
    BtnAdd,
    BtnDelete,
    BtnSave,
    BtnCsvDownload,
    TextFieldInput,
    TextFieldRef,
    TextAreaInput,
    TextAreaRef,
    TextFieldInputWithDatePicker,
    Checkbox,
    IconEdit,
    SearchBoxSamplingDialog,
    InspAttachmentForm,
    InspIndexDetail,
    MeasValueInput,
    UserInput,
    InspectorInput,
    DelConfirmDialog,
    NumConfirmDialog,
    DatetimePicker,
    ImpDataErrorDialog,
    BtnImport,
    FileInput,
    SelectSaDialog,
    InspTimingDtlInput,
    BtnAttach,
    InspectionFileAttachmentDialog,
  },

  props: {
    inspIndexNo: {
      type: String,
      required: true,
    },
    cav: {
      type: String,
      required: true,
    },
    numOfInsp: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      companyCatCd: this.$store.getters.companyCatCd,
      isSearched: false,
      isNew: false,
      isMeasEditMode: false,
      samplingBoxDialog: false,
      inspAttachDialog: false,
      confirmDialog: false,
      numConfirmDialog: false,
      ImpInspDataErrorDialog: false,
      selectSaDialog: false,
      isConfirmedSa: true,
      existsInspTimingConst: false,

      searchResult: {
        inspDate: '',
        inspectorCd: '',
        inspQty: null,
        inspResultCd: '',
        partRev: null,
        inspCharacRev: '',
        remarks: '',
        isOutCl: false,
        hasCl: false,
        characs: [],
        isMaxNum: false, // 表示中の検査回数がDB上のMAX値である
      },
      indexDetail: null,
      isComplete: false,
      inspStartDatetime: '',
      samplingBoxes: [],
      hasInspPoint: false,
      convItems: [],
      importFileErrorExists: false,
      files: [],
      errorList: [],
      errorLineCount: 0,
      saItems: [],
      cavLimit: 10,
      maxNumOfMeas: MAX_NUM_OF,
      inspFileAttachDialog: false,
      attachedFiles: [],
    }
  },

  computed: {
    enumInspClassCd: () => InspClassCd,
    tableHeight: {
      get() {
        let height = this.$vuetify.breakpoint.height * 0.5
        if (height < 400) {
          height = 400
        }
        return `${height}px`
      },
    },
    headers: {
      get() {
        let result = [
          { text: this.$t('ELE0091'), value: 'inspCharacCd', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0092'), value: 'inspCharacPoint', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0094'), value: 'inspGradeCd', divider: true, sortable: false, visible: true },
          {
            text: this.$t('ELE0095'),
            value: 'standard',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'normal-cell',
            cellClass: 'v-data-table__divider normal-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0096'),
            value: 'upper',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'normal-cell',
            cellClass: 'v-data-table__divider normal-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0097'),
            value: 'lower',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'normal-cell',
            cellClass: 'v-data-table__divider normal-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0538'),
            value: 'clUpper',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'normal-cell',
            cellClass: 'v-data-table__divider normal-cell',
            visible: this.searchResult.hasCl ? true : false,
          },
          {
            text: this.$t('ELE0539'),
            value: 'clLower',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'normal-cell',
            cellClass: 'v-data-table__divider normal-cell',
            visible: this.searchResult.hasCl ? true : false,
          },
          {
            text: this.$t('ELE0095'),
            value: 'saStandard',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'sa-cell',
            cellClass: 'v-data-table__divider sa-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0096'),
            value: 'saUpper',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'sa-cell',
            cellClass: 'v-data-table__divider sa-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0097'),
            value: 'saLower',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'sa-cell',
            cellClass: 'v-data-table__divider sa-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0388') + '/' + this.$t('ELE0392'),
            value: 'inspQltyStd',
            divider: true,
            sortable: false,
            visible: true,
          },
          { text: this.$t('ELE0184'), value: 'saNo', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0025'), value: 'measInstCd', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0181'), value: 'measResultCd', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0182'), value: 'cp', divider: true, sortable: false, align: 'end', visible: true },
          { text: this.$t('ELE0183'), value: 'cpk', divider: true, sortable: false, align: 'end', visible: true },
        ].filter((header) => header.visible)
        for (let i = 1; i <= this.maxNumOfMeas; i++) {
          result.push({
            text: String(i),
            value: `measValue${String(i)}`,
            divider: true,
            sortable: false,
            align: 'end',
            cellClass: 'py-1',
          })
        }
        return result
      },
    },
    canEdit: {
      // Formの編集可否判定
      get() {
        let result = false
        if (!this.isSearched) {
          result = false
          // 編集モード、かつ最新でない検査回数を表示中
        } else if (!this.isNew && !this.searchResult.isMaxNum) {
          result = false
          // 検査可能な検査状態か
        } else if (
          this.indexDetail.inspStatusCd != InspStatusCd.WAITING_FOR &&
          this.indexDetail.inspStatusCd != InspStatusCd.IN_PROGRESS
        ) {
          result = false
          // 検査タイミング詳細に登録されているか
        } else if (!this.existsInspTimingConst) {
          result = false
        } else {
          result = this.canInspCompany
        }
        return result
      },
    },
    canInspCompany: {
      get() {
        let result = false
        // ユーザーが検査可能な検査インデックスか
        if (!this.isInspectableCompany(this.indexDetail.inspCompanyCd, this.indexDetail.inspCompanyCatCd)) {
          result = false
        } else {
          result = true
        }
        return result
      },
    },
    canEditMeasValue: {
      // 測定値テーブルの編集可否判定
      get() {
        return this.canEdit && this.isMeasEditMode
      },
    },
    canDelete: {
      // 検査結果の削除可否判定
      get() {
        return !this.isNew && this.canEdit
      },
    },
    inspIndexNoComputed: {
      get() {
        return this.inspIndexNo
      },
      set(value) {
        this.$emit('update:inspIndexNo', value)
      },
    },
    cavComputed: {
      get() {
        return this.cav
      },
      set(value) {
        this.$emit('update:cav', value)
      },
    },
    numOfInspComputed: {
      get() {
        return this.numOfInsp
      },
      set(value) {
        this.$emit('update:numOfInsp', value)
      },
    },
    csvFileTitle: {
      get() {
        return `insp_dim_${this.indexDetail.partCd}_${this.indexDetail.lotNo}`
      },
    },
    csvContents: {
      get() {
        let items = []
        //0x12など数値リテラルの対策
        // 先頭から見て正しい数値までを10進数変換する
        // 123abc456 -> 123
        const max = Math.max(parseInt(this.searchResult.inspQty, 10), this.maxNumOfMeas)
        const len = isNaN(max) ? this.maxNumOfMeas : max
        for (let idx = 0; idx < this.searchResult.characs.length; idx++) {
          const charac = this.searchResult.characs[idx]
          let item = {}
          item[this.$t('ELE0157')] = this.cavComputed
          item[this.$t('ELE0098')] = this.numOfInspComputed
          item[this.$t('ELE0091')] = charac.inspCharacCd
          item[this.$t('ELE0092')] = charac.inspCharacPoint

          item[this.$t('ELE0095')] = charac.standard
          item[this.$t('ELE0096')] = charac.upper
          item[this.$t('ELE0097')] = charac.lower
          if (this.searchResult.hasCl) {
            item[this.$t('ELE0538')] = charac.clUpper
            item[this.$t('ELE0539')] = charac.clLower
          }
          item[this.$t('ELE0273')] = charac.saStandard
          item[this.$t('ELE0274')] = charac.saUpper
          item[this.$t('ELE0275')] = charac.saLower

          for (let num = 1; num <= len; num++) {
            item[[this.$t('ELE0202')] + num] = charac['measValue' + num]
          }

          item[this.$t('ELE0025')] = charac.measInstCd

          items.push(item)
        }

        return items
      },
    },
    canSave: {
      get() {
        let result = false
        if (this.canEdit) {
          if (this.measValueExists) {
            result = true
          }
        }
        return result
      },
    },
    measValueExists: {
      get() {
        if (this.searchResult) {
          for (let i = 0; i < this.searchResult.characs.length; i++) {
            for (let j = 1; j <= this.maxNumOfMeas; j++) {
              if (this.hasJsonValue(this.searchResult.characs[i], `measValue${j}`)) {
                return true
              }
            }
          }
        }
        return false
      },
    },
    canSelectSa: {
      get() {
        let result = false
        if (this.canEdit && this.isNew && this.saItems.length > 0) {
          result = true
        }
        return result
      },
    },
    selectedSaNoList: {
      get() {
        let saNolist = []
        this.saItems.forEach((el) => {
          if (el.isSelected) {
            saNolist.push(el.saNo)
          }
        })
        return saNolist
      },
    },
    measResultCols: {
      get() {
        // 画面から編集できない測定回数以上の列を表示するために使用
        let result = []
        for (let i = MAX_NUM_OF + 1; i <= this.maxNumOfMeas; i++) {
          result.push(`measValue${i}`)
        }
        return result
      },
    },
    fileAttachmentBtnComputed: {
      get() {
        return this.inspIndexNoComputed && this.cavComputed && this.numOfInspComputed
      },
    },
    attachedFilesComputed: {
      get() {
        return this.attachedFiles
      },
    },
    inspCharacExists: {
      get() {
        return this.searchResult.characs.length > 0
      },
    },
    drawingStandardColSpan: {
      get() {
        let result = 3
        if (this.searchResult.hasCl) {
          result = 5
        }
        return result
      },
    },
    csvHeaderLength: {
      get() {
        let result = 10
        if (this.searchResult.hasCl) {
          result += 2
        }
        return result
      },
    },
  },

  watch: {
    inspIndexNoComputed: {
      async handler(value) {
        if (value) {
          await this.setSaInInsp()
          await this.search(this.inspIndexNoComputed, this.cavComputed, this.numOfInspComputed)

          if (this.isNew) {
            this.isConfirmedSa = this.saItems.length > 0 ? false : true
          } else if (this.indexDetail != null && this.indexDetail.saNoList.length > 0) {
            await this.setSaInInsp()
          }
        } else {
          this.isSearched = false
        }
      },
      immediate: true,
    },
    numOfInspComputed: {
      handler(value) {
        if (value) {
          this.setAttachedFiles(value)
        }
      },
    },
  },

  methods: {
    onClickEdit() {
      this.maxNumOfMeas = this.searchResult.inspQty
      this.isMeasEditMode = true
    },
    showInspResultName(key, value, isOutCl) {
      return this.getInspResultName(key, value, isOutCl)
    },

    getColorMeasResult(measResultCd) {
      // 測定結果に対応する色設定
      let color = ''

      if (measResultCd == MeasResultCd.OK) {
        color = '#EDEFFD'
      } else if (measResultCd == MeasResultCd.SA_OK) {
        color = '#FCF4A1'
      } else if (measResultCd == MeasResultCd.NG) {
        color = '#F8CED2'
      }

      return color
    },

    async setSaInInsp() {
      try {
        this.saItems = await API.get('/sa/insp', {
          inspClassCd: InspClassCd.DIM,
          inspIndexNo: this.inspIndexNoComputed,
          saNoList: this.indexDetail == null ? [] : this.indexDetail.saNoList,
        })
      } catch (error) {
        this.saItems = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0291') })))
      }
    },

    async applySa(items) {
      this.isConfirmedSa = true
      this.saItems = items

      const inspStartDatetime = this.inspStartDatetime
      const tmpNumOfInsp = this.numOfInspComputed
      const inspQty = this.searchResult.inspQty
      const isComplete = this.isComplete
      const isNew = this.isNew
      const inspTimingDtl = this.searchResult.inspTimingDtlCd
      await this.search(this.inspIndexNoComputed, null, null)
      this.inspStartDatetime = inspStartDatetime
      this.numOfInspComputed = tmpNumOfInsp
      this.searchResult.inspQty = inspQty
      this.isComplete = isComplete
      this.isNew = isNew
      this.searchResult.inspTimingDtlCd = inspTimingDtl
    },

    async search(inspIndexNo, cav, numOfInsp) {
      try {
        this.startLoading()

        this.searchResult = await API.get('/inspDim', {
          inspIndexNo: inspIndexNo,
          cav: cav,
          numOfInsp: numOfInsp,
          saNoList: this.selectedSaNoList,
        })
        this.maxNumOfMeas = this.searchResult.maxNumOfMeas ? this.searchResult.maxNumOfMeas : MAX_NUM_OF // 新規作成時を考慮
        this.numOfInspComputed = this.searchResult.numOfInsp
        this.searchResult.inspDate = this.searchResult.inspDate
          ? this.searchResult.inspDate
          : moment().format('YYYY-MM-DD')
        this.searchResult.inspectorCd = this.searchResult.inspectorCd
          ? this.searchResult.inspectorCd
          : this.$store.getters.userCd
        this.convertMeasValue()

        const indexDetail = await API.get('/inspIndex/inspIndexes/' + this.inspIndexNoComputed + '/lot', {
          partRev: this.searchResult.partRev,
        })
        indexDetail.saNoList = this.getSaNoList(this.searchResult.characs)
        this.indexDetail = indexDetail

        this.samplingBoxes = await this.searchBoxSampling(
          indexDetail.inspTimingCd,
          indexDetail.manufacturerCd,
          indexDetail.partCd,
          indexDetail.lotNo,
        )
        this.hasInspPoint = await this.existsPartInspPoints(indexDetail.partCd)

        const inspTimingConst = await this.getInspTimingConst()
        if (inspTimingConst.length) {
          this.existsInspTimingConst = true
        }

        if (this.numOfInspComputed) {
          this.isNew = false
        } else {
          this.isNew = true
        }

        if (indexDetail.inspStartDatetime == null) {
          this.inspStartDatetime = moment().format('YYYY-MM-DD HH:mm:00')
        } else {
          this.inspStartDatetime = this.toLocalTime(indexDetail.inspStartDatetime)
        }

        this.isMeasEditMode = false
        this.isComplete = false
        this.isSearched = true

        if (this.searchResult.dimAttachmentList?.length > 0) {
          this.onSetAttachedFiles(this.searchResult.dimAttachmentList)
        }
      } catch (error) {
        this.isSearched = false
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      } finally {
        this.stopLoading()
      }
    },

    convertMeasValue() {
      // 測定結果を表示しやすいように変換
      for (let idx = 0; idx < this.searchResult.characs.length; idx++) {
        const charac = this.searchResult.characs[idx]

        for (let num = 1; num <= this.maxNumOfMeas; num++) {
          let obj = charac.measValueList.find((m) => m.numOfMeas == num)
          charac['measValue' + num] = obj ? obj.measValue : ''
        }
      }
    },
    formatValue(value, measFmtCd) {
      // 測定方法がOK_NGの場合、enum変換する
      if (value && measFmtCd == MeasFmtCd.OK_NG) {
        value = this.$t(`DimJudgeCd.${value}`)
      }
      return value
    },

    async setNumOfInsp() {
      try {
        this.startLoading()

        if (this.cavComputed) {
          const maxNumOfInsp = await API.get('/inspDim/maxNumOfInsp', {
            inspIndexNo: this.inspIndexNoComputed,
            cav: this.cavComputed,
          })

          if (maxNumOfInsp) {
            this.numOfInspComputed = maxNumOfInsp + 1
          } else {
            this.numOfInspComputed = 1
          }
        } else {
          this.numOfInspComputed = null
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0098') })))
      } finally {
        this.stopLoading()
      }
    },

    getSaNoList(characs) {
      // 全特性からSA Noを抽出 (重複するSA Noは排除)
      let items = []
      if (characs.length) {
        characs.forEach(function (element) {
          if (element.saNo) {
            items.push(element.saNo)
          }
        })
        items = Array.from(new Set(items))
      }
      return items
    },

    async onClickSave() {
      // 保存
      try {
        this.startLoading()

        if (await this.validate()) {
          await this.save()
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0159') })))
      } finally {
        this.stopLoading()
      }
    },

    async validate() {
      // 入力チェック
      if (!(await this.$refs.observer.validate())) {
        return false
      }

      if (this.isNewNumOfInsp()) {
        this.numConfirmDialog = true
        return false
      }
      return true
    },

    isNewNumOfInsp() {
      // 2以上の検査回数で検査データを登録しようとしているか判定
      let result = false
      if (this.isNew && this.numOfInspComputed > 1) {
        result = true
      }
      return result
    },

    async onProceedSave() {
      // 保存
      try {
        this.startLoading()
        this.numConfirmDialog = false
        await this.save()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0159') })))
      } finally {
        this.stopLoading()
      }
    },

    async save() {
      // 保存
      await this.uploadAttachedFile()
      const body = {
        inspIndexNo: this.inspIndexNoComputed,
        cav: this.cavComputed,
        inspTimingDtlCd: this.searchResult.inspTimingDtlCd,
        numOfInsp: this.numOfInspComputed,
        inspDate: this.searchResult.inspDate,
        inspectorCd: this.searchResult.inspectorCd,
        inspQty: this.searchResult.inspQty,
        inspResultCd: this.searchResult.inspResultCd,
        partRev: this.searchResult.partRev,
        inspCharacRev: this.searchResult.inspCharacRev,
        remarks: this.searchResult.remarks,
        characs: this.searchResult.characs,
        versionNo: this.indexDetail.versionNo,
        isComplete: this.isComplete,
        inspStartDatetime: this.toServerTime(this.inspStartDatetime),
        dimAttachmentList: this.attachedFiles,
        isOutCl: this.searchResult.isOutCl,
      }

      await API.post('/inspDim/register', body)

      this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0159') }))
      this.resetForm()
    },

    async onProceedDelete() {
      // 削除
      try {
        this.startLoading()

        const body = {
          inspIndexNo: this.inspIndexNoComputed,
          cav: this.cavComputed,
          numOfInsp: this.numOfInspComputed,
          versionNo: this.indexDetail.versionNo,
        }

        await API.post('/inspDim/delete', body)

        this.setSuccessMessage(this.$t('MSG0014'))
        this.resetForm()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0004', { p0: this.$t('ELE0159') })))
      } finally {
        this.stopLoading()
      }
    },

    resetForm() {
      this.isSearched = false
      this.$emit('reset')
    },

    setInspResult() {
      // 寸法検査全体の検査結果判定
      if (
        this.searchResult.characs.some(function (el) {
          return el.measResultCd == MeasResultCd.NG
        })
      ) {
        // 1件でもNGあり
        this.searchResult.inspResultCd = MeasResultCd.NG
      } else if (
        this.searchResult.characs.some(function (el) {
          return el.measResultCd == MeasResultCd.SA_OK
        })
      ) {
        // 1件でもSA合格あり
        this.searchResult.inspResultCd = MeasResultCd.SA_OK
      } else if (
        this.searchResult.characs.some(function (el) {
          return el.measResultCd == MeasResultCd.OK
        })
      ) {
        // 1件でも合格あり
        this.searchResult.inspResultCd = MeasResultCd.OK
      } else {
        this.searchResult.inspResultCd = null
      }
      let isOutCl = false
      if (this.searchResult.characs.some((el) => el.isOutCl)) {
        // 1件でも管理限界外あり
        isOutCl = true
      }
      this.searchResult.isOutCl = isOutCl
    },

    setCharacResult(index) {
      // 特性1つ分の測定結果設定
      let charac = this.searchResult.characs[index]
      const measFmtCd = charac.measFmtCd
      let hasNg = false
      let hasSaOk = false
      let hasOk = false
      let isOutCl = false

      for (let idx = 1; idx <= this.maxNumOfMeas; idx++) {
        // 未入力欄は検査結果を判定せずにスキップ
        if (!this.hasJsonValue(charac, `measValue${idx}`)) {
          continue
        }

        const measValue = charac[`measValue${idx}`]
        if (isNaN(measValue)) {
          // 数値以外の入力はNG
          hasNg = true
        } else if (measFmtCd == MeasFmtCd.NUMBER) {
          // 数値入力
          if (charac.saNo) {
            // 有効なSAあり
            if (this.judgeNumber(measValue, charac.saStandard, charac.saUpper, charac.saLower)) {
              hasSaOk = true
            } else {
              hasNg = true
            }
          } else {
            // 有効なSAなし
            if (this.judgeNumber(measValue, charac.standard, charac.upper, charac.lower)) {
              hasOk = true
            } else {
              hasNg = true
            }
          }
          // 管理限界外チェック
          if (this.isOverCl(measValue, charac.standard, charac.clUpper, charac.clLower)) {
            isOutCl = true
          }
        } else if (measFmtCd == MeasFmtCd.OK_NG) {
          // 合否入力
          if (this.judgeOkNg(measValue)) {
            hasOk = true
          } else {
            hasNg = true
          }
        }
      }

      let measResultCd = ''
      if (hasNg) {
        measResultCd = MeasResultCd.NG
      } else if (hasSaOk) {
        measResultCd = MeasResultCd.SA_OK
      } else if (hasOk) {
        measResultCd = MeasResultCd.OK
      }

      charac.measResultCd = measResultCd
      charac.isOutCl = isOutCl
      this.searchResult.characs.splice(index, 1, charac)
      this.setInspResult()
    },

    hasJsonValue(json, key) {
      return key in json && json[key] !== '' && json[key] !== null
    },

    judgeNumber(measValue, std, upper, lower) {
      // 数値入力の測定結果判定
      if (!std) {
        std = 0
      }
      if (!lower) {
        lower = 0
      }
      if (!upper) {
        upper = 0
      }

      let result = true
      if (BigNumber(BigNumber(std).plus(lower)).gt(BigNumber(measValue))) {
        result = false
      } else if (BigNumber(measValue).gt(BigNumber(std).plus(upper))) {
        result = false
      }
      return result
    },

    isOverCl(measValue, std, clUpper, clLower) {
      if (!std) {
        std = 0
      }
      let result = false
      if (this.hasValue(clLower) && BigNumber(BigNumber(std).plus(clLower)).gt(BigNumber(measValue))) {
        result = true
      } else if (this.hasValue(clUpper) && BigNumber(measValue).gt(BigNumber(std).plus(clUpper))) {
        result = true
      }
      return result
    },

    hasValue(value) {
      return value !== '' && value !== null
    },

    judgeOkNg(measValue) {
      // 合否入力の測定結果判定
      let result = true
      if (measValue == DimJudgeCd.NG) {
        result = false
      }
      return result
    },

    async searchBoxSampling(inspTimingCd, manufacturerCd, partCd, lotNo) {
      // サンプリング検査箱取得
      let boxes = []

      try {
        const params = {
          inspTimingCd: inspTimingCd,
          manufacturerCd: manufacturerCd,
          partCd: partCd,
          lotNo: lotNo,
        }
        boxes = await API.get('/box/sampling/lot', params)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0186') })))
      }

      return boxes
    },

    async existsPartInspPoints(partCd) {
      // 検査添付ファイルマスタの存在チェック
      let hasInspPoint = false

      try {
        const params = {
          partCd: partCd,
        }
        const inspPoints = await API.get('/master/partInspPoints', params)

        if (inspPoints.length > 0) {
          hasInspPoint = true
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0034') })))
      }

      return hasInspPoint
    },

    //-------------------
    // 検査データCSV取込
    //-------------------
    async onClickImport() {
      try {
        this.startLoading()
        await this.csvToJson(this.files)
        if (!this.importFileErrorExists) {
          await this.checkInspData(this.convItems)
        } else {
          this.setErrorMessage(this.$t('MSG0028'))
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0206') })))
      } finally {
        this.importFileErrorExists = false
        this.files = []
        this.stopLoading()
      }
    },
    async csvToJson(files) {
      let filesData = []
      await Promise.all(
        files.map(
          (file) =>
            new Promise((resolve, reject) => {
              this.$papa.parse(file, {
                skipEmptyLines: true,
                complete: resolve,
                error: reject,
              })
            }),
        ),
      )
        .catch((error) => {
          throw error
        })
        .then((results) => {
          results.forEach((result) => {
            filesData.push(result.data)
          })
        })
      this.convertItems(filesData)
    },
    convertItems(parseData) {
      let items = []
      if (parseData.length < 1 || parseData[0].length <= 1) {
        this.importFileErrorExists = true
      } else {
        parseData.forEach((parseData, fileIndex) => {
          // 末尾追加分は数をチェックしない
          if (parseData[0].length < this.csvHeaderLength + 1) {
            this.importFileErrorExists = true
          }
          for (let index = 1; index <= parseData.length - 1; index++) {
            let item = {
              fileName: this.files[fileIndex].name,
              index: index,
              cav: parseData[index][0],
              numOfInsp: parseData[index][1],
              inspCharacCd: parseData[index][2],
              inspCharacPoint: parseData[index][3],
              values: [],
            }
            // 入力されている検査数分取り込む 末尾に何か追加されていても読み込まない
            for (let i = 0; i <= Number(this.searchResult.inspQty) - 1; i++) {
              item.values.push(parseData[index][i + this.csvHeaderLength])
            }
            items.push(item)
          }
        })
      }
      this.convItems = items
    },
    async checkInspData(data) {
      if (data.some((element) => element.cav != this.cavComputed || element.numOfInsp != this.numOfInsp)) {
        this.setErrorMessage(this.$t('MSG0180'))
        return
      }
      const body = {
        inspIndexNo: this.inspIndexNoComputed,
        inspStartDatetime: this.toServerTime(this.inspStartDatetime),
        importData: data,
        saNoList: this.indexDetail.saNoList, // 更新モードで本画面を開いてもsaNoを渡せるよう、indexDetailのsaNoを指定
      }
      const elements = await API.post('/inspDim/files/check', body)
      this.errorList = []
      if (elements.errorExists) {
        this.errorLineCount = elements.errorLineCount
        elements.errorMessages.forEach((element) => {
          let item = {}
          item.fileName = element['fileName']
          item.line = element['lineNo'] + 1
          item.detail = element.bodies.join('\r\n')
          this.errorList.push(item)
        })
        this.ImpInspDataErrorDialog = true
      } else {
        await this.registerInspData(data)
      }
    },
    async registerInspData(data) {
      await this.uploadAttachedFile()
      const body = {
        inspIndexNo: this.inspIndexNoComputed,
        inspDate: this.searchResult.inspDate,
        inspStartDatetime: this.toServerTime(this.inspStartDatetime),
        inspector: this.searchResult.inspectorCd,
        importData: data,
        inspQty: this.searchResult.inspQty,
        inspTimingDtlCd: this.searchResult.inspTimingDtlCd,
        indexVersionNo: this.indexDetail.versionNo,
        saNoList: this.indexDetail.saNoList, // 更新モードで本画面を開いてもsaNoを渡せるよう、indexDetailのsaNoを指定
        dimAttachmentList: this.attachedFiles,
      }
      await API.post('/inspDim/files/register', body)
      this.setSuccessMessage(this.$t('MSG0075'))
      await setImmediate(() => this.search(this.inspIndexNoComputed, this.cavComputed, null))
    },
    async setParameter() {
      try {
        const param = await API.get(`/master/systemParameter/${SystemParameterKey.INSP_CAV_LIMIT}`)
        if (param) {
          this.cavLimit = Number(param.value) > 0 ? Number(param.value) : 10
        }
      } catch (error) {
        this.cavLimit = 10
        if (error.response.status != 404) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0348') })))
        }
      }
    },
    async getInspTimingConst() {
      let result = []
      try {
        let params = {
          companyCatCd: this.$store.getters.companyCatCd,
          inspTimingCd: this.indexDetail.inspTimingCd,
          inspClassCd: InspClassCd.DIM,
          inspCat2: this.indexDetail.inspCat2Cd,
        }
        if (!this.isNew) params.inspTimingDtlCd = this.searchResult.inspTimingDtlCd
        result = await API.get('/master/inspTimingConstraints', params)
      } catch (error) {
        result = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      }
      return result
    },

    async setAttachedFiles() {
      try {
        this.startLoading()

        if (this.cavComputed) {
          const dimAttachmentFiles = await API.get('/inspDim/inspAttachment', {
            inspIndexNo: this.inspIndexNoComputed,
            cav: this.cavComputed,
            numOfInsp: this.numOfInspComputed,
          })

          if (dimAttachmentFiles?.length > 0) {
            this.onSetAttachedFiles(dimAttachmentFiles)
          }
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0527') })))
      } finally {
        this.stopLoading()
      }
    },
    async uploadAttachedFile() {
      for (let index = 0; index < this.attachedFiles.length; index++) {
        this.attachedFiles[index].dtlNo = index + 1
        if (!this.attachedFiles[index].filePath) {
          this.attachedFiles[index].filePath = await Storage.uploadFile(
            this.attachedFiles[index].file,
            'insp/' + this.inspIndexNo + '/' + S3Root.INSP_DIM,
          )
          this.attachedFiles[index]['cav'] = this.cavComputed
          this.attachedFiles[index]['inspIndexNo'] = this.inspIndexNo
          this.attachedFiles[index]['numOfInsp'] = this.numOfInsp
          this.attachedFiles[index].file = null
        }
      }
    },

    onSetAttachedFiles(fileList) {
      this.attachedFiles = fileList.map((element) => {
        if (!element.filename) {
          return {
            ...element,
            filename: element.filePath.split('/').pop(),
          }
        }
        return element
      })
    },
  },
  async mounted() {
    await this.setParameter()
  },
}
</script>
<style>
.normal-cell {
  background-color: #edeffd !important;
}
.sa-cell {
  background-color: #fcf4a1 !important;
}
</style>
